export const dateInYyyyMmDdHhMmSs = (date, dateDiveder = "-") => {
    return (
      [
        date.getFullYear(),
        padTwoDigits(date.getMonth() + 1),
        padTwoDigits(date.getDate()),
      ].join(dateDiveder) +
      " " +
      [
        padTwoDigits(date.getHours()),
        padTwoDigits(date.getMinutes()),
        padTwoDigits(date.getSeconds()),
      ].join(":")
    );
  }
  
  const padTwoDigits = (num) => {
    return num.toString().padStart(2, "0");
  }